import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { PaymentPage } from './payment.page';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared-module/shared.module';
import { PaymentPageRoutingModule } from './payment-routing.module';

@NgModule({
  imports: [
    FormsModule,
    IonicModule,
    CommonModule,
    SharedModule,
    PaymentPageRoutingModule
  ],
  declarations: [PaymentPage]
})
export class PaymentPageModule {}
